<template>
  <v-flex xs12 lg8>
    <div class="version-entry">
      <div v-if="currentMode === 2">
        <v-btn color="primary" x-small outlined @click="closeForm()">
          <v-icon left>fa fa-times</v-icon>Close
        </v-btn>
        <h4>Update URL Results</h4>
        <p></p>
        <v-container>
          <v-row v-for="result in submissionResults" :key="result.requestData.variant">
            <v-col>
              <span class="label">{{result.requestData.variant}} -> {{result.response.status}}</span>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div v-else-if="currentMode === 1">
<!--        In this mode the top level vue loading spinner shows because a jigapi request is active-->
      </div>
      <div v-else>
      <v-btn color="primary" x-small outlined @click="closeForm()">
        <v-icon left>fa fa-times</v-icon>Close
      </v-btn>
      <h4>Are you sure</h4>
        Do you wish to update all the JigSpace desktop app download URLs for environment: <strong>{{ environment }}</strong>?
      <p></p>
        <v-container>
          <v-row v-for="data in requestsData" :key="data.variant">
            <v-col>
              <div v-if="data.optionalTestingDeeplink !== null" class="label">
                Testing deeplink URL: <a v-bind:href="data.optionalTestingDeeplink">{{ data.optionalTestingDeeplink }}</a>
                <span class="label">Proposed download URL ({{data.variant}}): <a v-bind:href="data.downloadTargetUrl">{{ data.downloadTargetUrl }}</a></span>
              </div>
              <div v-else>
                <span class="label">Proposed PRODUCTION download URL ({{data.variant}}): <a v-bind:href="data.downloadTargetUrl">{{ data.downloadTargetUrl }}</a></span>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-btn class="btn-primary mt-4" color="primary" size="sm" :loading="currentMode === 1" @click="submitUpdate()">
          <v-icon left>fa fa-wrench</v-icon>
          Yes - Update URLs
        </v-btn>
    </div>
    </div>
  </v-flex>
</template>

<script>
import {
  DefaultApplication,
  PlatformsOptions,
} from '@/modules/library/constants';
import { mapActions, mapState } from 'vuex';
import { appDownloadDeeplinks } from '@/store/modules/Constants';
import auth from '@/auth/authService';

const modeConfirming = 0
const modeSubmitting = 1
const modeResults = 2

export default {
  name: "AppDeeplinkUpdater.vue",
  components: {
  },
  props: {
    currentVersionName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isFormValid: false,
      app: DefaultApplication,
      currentVersion: this.currentVersionName,
      currentMode: modeConfirming,
      requestsData: [],
      submissionResults: [],
      environment: auth.dashboardEnv,
    };
  },
  async created() {
    this.currentMode = modeConfirming
    this.determineDownloadUrls()
  },
  watch: {},
  computed: {
    ...mapState('version', ['latestVersion']),
    version() {
      const currentVersion = this.latestVersion[this.app];

      return currentVersion || {};
    },
  },
  methods: {
    ...mapActions('version', ['updateBranchIODeeplinkDownloadUrl']),
    determineDownloadUrls() {
      if (!this.currentVersion) {
        return;
      }

      this.requestsData = []
      for (const item of appDownloadDeeplinks.jigspace) {
        if (item.platform === PlatformsOptions.desktop) {
          let platformName = ''
          let dotExtension = ''
          if (item.variant === 'macos') {
            platformName = 'MacOS'
            dotExtension = '.zip'
          } else if (item.variant === 'win-zip') {
            platformName = 'Win'
            dotExtension = '.zip'
          } else if (item.variant === 'win') {
            platformName = 'Win'
            dotExtension = '.exe'
          } else {
            consoleError('unhandled platform type: ' + item.platform)
            return
          }

          // Format of a download target that hits JigSpace S3 directly and avoids CF:-
          // downloadTargetUrl: `https://jigspace-desktop.s3.amazonaws.com/${this.version.Version}/JigSpace_${platformName}_${this.version.Version}${dotExtension}`,
          // Format of a download target that hits the CloudFront cache of the S3 bucket:-
          // downloadTargetUrl: `https://dnkv99gmr79m7.cloudfront.net/${this.version.Version}/JigSpace_${platformName}_${this.version.Version}${dotExtension}`,
          // We use the CF cached target for faster download speeds.
          const req = {
            app: DefaultApplication,
            platform: item.platform.toLowerCase(),
            variant: item.variant,
            downloadTargetUrl: `https://dnkv99gmr79m7.cloudfront.net/${this.version.Version}/JigSpace_${platformName}_${this.version.Version}${dotExtension}`,
          }
          if (auth.dashboardEnv !== 'production') {
            req.optionalTestingDeeplink = item.nonProdDeeplinkUrl
          }

          this.requestsData.push(req)
        }
      }
    },
    closeForm() {
      this.$emit('on-app-deeplink-update-form-close');
    },
    async submitUpdate() {
      for (const data of this.requestsData) {
        const res = await this.updateBranchIODeeplinkDownloadUrl(data)
        this.submissionResults.push({
          requestData: data,
          response: res,
        })
        if (res.status === 'success') {
          consoleLog('Successfully updated branch IO deeplink download URL for variant: ' + data.variant)
        } else {
          consoleError('FAILED to update branch IO deeplink download URL for variant: ' + data.variant)
        }
      }
      this.currentMode = modeResults
    },
  },
}
</script>

<style scoped>

</style>
